<template>
  <svg class="w-6 h-6 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <!-- Corps du wallet -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M3 7h18v10H3V7z" />
    <!-- Clapet / bouton -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M15 12a1 1 0 11-2 0 1 1 0 012 0z" />
    <!-- Détail ouverture wallet -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M3 7l3-3h12l3 3" />
  </svg>
</template>

<script>
export default {
  name: "WalletIcon",
};
</script>
